import {Validators} from "@angular/forms";
import {TableCols} from "../interfaces/static-data";

export const CURRENCY_REGION_OPTIONS = [
  {
    id: 'Europe',
    displayValue: 'Europe',
  },
  {
    id: 'America',
    displayValue: 'America',
  },
  {
    id: 'Asia',
    displayValue: 'Asia',
  }
]

export const CURRENCIES: TableCols[] = [
  {
    key: 'shortName',
    displayValue: 'ISO Code',
    validators: [Validators.required, Validators.pattern('^[a-zA-Z]{3}$')],
  },
  {
    key: 'longName',
    displayValue: 'Name',
    validators: [Validators.required],
  },
  {
    key: 'settlementCalendarCode',
    displayValue: 'Settlement Calendar',
    type: 'select',
    items: [],
    validators: [Validators.required],
  },
  {
    key: 'region',
    displayValue: 'Region',
    type: 'select',
    items: CURRENCY_REGION_OPTIONS,
  },
  {
    key: 'roundingRule',
    displayValue: 'Rounding Rule',
    validators: [],
  },
  {
    key: 'isEmergingMarket',
    displayValue: 'Is Emerging Market',
    type: 'boolean',
    validators: [Validators.required],
  },
  {
    key: 'interestRateRef',
    displayValue: 'Interest Rate Reference',
    type: 'select',
    items: [],
    validators: [],
  },
  {
    key: 'ricReferenceInterestRate',
    displayValue: 'RIC Reference Interest Rate',
    type: 'translate'
  },
  {
    key: 'paymentDateOffset',
    displayValue: 'Payment Date Offset',
    type: 'number',
    validators: [Validators.min(1)]
  },
  {
    key: 'workflowStatus',
    displayValue: 'Workflow Status',
    hideOnForm: true
  },
  {
    key: 'lastUpdatedBy',
    displayValue: 'Last Updated By',
    hideOnForm: true
  },
  {
    key: 'updatedOn',
    displayValue: 'Updated On',
    hideOnForm: true
  },
];
